module.exports = __webpack_public_path__ + "img/SunExpertWallpaper2.135bb053.jpg";